/**
 * Who joined Fly lately, for the landing pages' strip (JoinedCarousel): the start page's own read
 * (signupData fetchProof, B1's public route GET /api/gbp-agent/signup-proof, real switch-ons only), once on mount.
 * null while it reads, and null when the read fails or answers without its list, so a caller draws nothing then.
 * The start page keeps its own read in StartProofBlock; both go through fetchProof, so the request is written once.
 */
import { useEffect, useState } from 'react';
import { fetchProof } from '@/components/growth-agent/start/signup/signupData';
import type { SignupProof } from '@/components/growth-agent/start/signup/signupTypes';

export function useJoinedProof(): SignupProof | null {
  const [proof, setProof] = useState<SignupProof | null>(null);
  useEffect(() => {
    let dropped = false;
    void fetchProof().then((p) => {
      if (!dropped) setProof(p && Array.isArray(p.joined) ? p : null);
    });
    return () => {
      dropped = true;
    };
  }, []);
  return proof;
}

export default useJoinedProof;
